// eslint-disable
import { ComponentClass, FunctionComponent } from 'react';

import AccountCircleOff from './account_circle_off.svg';
import AccountCircleOn from './account_circle_on.svg';
import AddPicture from './add_picture.svg';
import ArrowDown from './arrow_down.svg';
import ArrowLeft from './arrow_left.svg';
import ArrowRight from './arrow_right.svg';
import ArrowUp from './arrow_up.svg';
import AttachFile from './attach_file.svg';
import AutoAwesome from './auto_awesome.svg';
import AutoFixHigh from './auto_fix_high.svg';
import BoxOff from './box_off.svg';
import Cached from './cached.svg';
import ChatBubbleNow from './chat_bubble_now.svg';
import ChatBubbleOff from './chat_bubble_off.svg';
import ChatBubbleOn from './chat_bubble_on.svg';
import Check from './check.svg';
import CheckBoxOff from './check_box_off.svg';
import CheckBoxOn from './check_box_on.svg';
import CheckCircleOff from './check_circle_off.svg';
import CheckCircleOn from './check_circle_on.svg';
import Close from './close.svg';
import CloseCircle from './close_circle.svg';
import CloudDownloadOff from './cloud_download_off.svg';
import CloudDownloadOn from './cloud_download_on.svg';
import CreditCard from './credit_card.svg';
import DashboardOff from './dashboard_off.svg';
import DashboardOn from './dashboard_on.svg';
import DeleteOff from './delete_off.svg';
import DeleteOn from './delete_on.svg';
import Download from './download.svg';
import DragHandle from './drag_handle.svg';
import DropArrowDown from './drop_arrow_down.svg';
import DropArrowUp from './drop_arrow_up.svg';
import Edit from './edit.svg';
import EventOff from './event_off.svg';
import EventOn from './event_on.svg';
import ExploreOff from './explore_off.svg';
import ExploreOn from './explore_on.svg';
import FavoriteOff from './favorite_off.svg';
import FavoriteOn from './favorite_on.svg';
import FlagOff from './flag_off.svg';
import FlagOn from './flag_on.svg';
import FolderOff from './folder_off.svg';
import FolderOn from './folder_on.svg';
import Graph from './graph.svg';
import HelpOutline from './help_outline.svg';
import InsertComment from './insert_comment.svg';
import InsertLink from './insert_link.svg';
import Insta from './insta_icon.svg';
import InstaReels from './insta_reels.svg';
import List from './list.svg';
import LockOff from './lock_off.svg';
import LockOn from './lock_on.svg';
import Memory from './memory.svg';
import Menu from './menu.svg';
import MoreHoriz from './more_horiz.svg';
import MoreVert from './more_vert.svg';
import NaverBlog from './naver_blog.svg';
import Navigation from './navigation.svg';
import NotificationNow from './notification_now.svg';
import NotificationOff from './notification_off.svg';
import NotificationOn from './notification_on.svg';
import OfferOff from './offer_off.svg';
import OfferOn from './offer_on.svg';
import OfflineBoltOff from './offline_bolt_off.svg';
import OfflineBoltOn from './offline_bolt_on.svg';
import OutLink from './out_link.svg';
import Picture from './picture.svg';
import Pin from './pin.svg';
import Public from './public.svg';
import RadioButtonOff from './radio_button_off.svg';
import RadioButtonOn from './radio_button_on.svg';
import RankingOff from './ranking_off.svg';
import RankingOn from './ranking_on.svg';
import RemoveCircleOff from './remove_circle_off.svg';
import RemoveCircleOn from './remove_circle_on.svg';
import RedEyeOff from './remove_red_eye_off.svg';
import RedEyeOn from './remove_red_eye_on.svg';
import Search from './search.svg';
import Settings from './settings.svg';
import ShoppingCartOff from './shopping_cart_off.svg';
import ShoppingCartOn from './shopping_cart_on.svg';
import SideBarOff from './sidebar_left_off.svg';
import SkipNext from './skip_next.svg';
import SkipPrev from './skip_prev.svg';
import StarOff from './star_off.svg';
import StarOn from './star_on.svg';
import SupportAgent from './support_agent.svg';
import Tiktok from './tiktok.svg';
import Timer from './timer.svg';
import ToggleOff from './toggle_off.svg';
import ToggleOn from './toggle_on.svg';
import Tune from './tune.svg';
import UploadFile from './upload_file.svg';
import Verified from './verified.svg';
import Video from './video.svg';
import Warning from './warning.svg';
import Youtube from './youtube.svg';
import YoutubeShorts from './youtube_shorts.svg';

const icon_key_list = [
	'AccountCircleOff',
	'AccountCircleOn',
	'AddPicture',
	'ArrowDown',
	'ArrowLeft',
	'ArrowRight',
	'ArrowUp',
	'AttachFile',
	'AutoAwesome',
	'AutoFixHigh',
	'BoxOff',
	'Cached',
	'ChatBubbleNow',
	'ChatBubbleOff',
	'ChatBubbleOn',
	'CheckBoxOff',
	'CheckBoxOn',
	'CheckCircleOff',
	'CheckCircleOn',
	'Check',
	'CloseCircle',
	'Close',
	'CloudDownloadOff',
	'CloudDownloadOn',
	'CreditCard',
	'DashboardOff',
	'DashboardOn',
	'DeleteOff',
	'DeleteOn',
	'Download',
	'DragHandle',
	'DropArrowDown',
	'DropArrowUp',
	'Edit',
	'EventOff',
	'EventOn',
	'ExploreOff',
	'ExploreOn',
	'FavoriteOff',
	'FavoriteOn',
	'FlagOff',
	'FlagOn',
	'FolderOff',
	'FolderOn',
	'Graph',
	'HelpOutline',
	'InsertComment',
	'InsertLink',
	'Insta',
	'InstaReels',
	'List',
	'LockOff',
	'LockOn',
	'Memory',
	'Menu',
	'MoreHoriz',
	'MoreVert',
	'NaverBlog',
	'Navigation',
	'NotificationNow',
	'NotificationOff',
	'NotificationOn',
	'OfferOff',
	'OfferOn',
	'OfflineBoltOff',
	'OfflineBoltOn',
	'OutLink',
	'Picture',
	'Pin',
	'Public',
	'RadioButtonOff',
	'RadioButtonOn',
	'RankingOff',
	'RankingOn',
	'RemoveCircleOff',
	'RemoveCircleOn',
	'RedEyeOff',
	'RedEyeOn',
	'Search',
	'Settings',
	'ShoppingCartOff',
	'ShoppingCartOn',
	'SideBarOff',
	'SkipNext',
	'SkipPrev',
	'StarOff',
	'StarOn',
	'SupportAgent',
	'Tiktok',
	'Timer',
	'ToggleOff',
	'ToggleOn',
	'Tune',
	'UploadFile',
	'Video',
	'Verified',
	'Warning',
	'YoutubeShorts',
	'Youtube',
] as const;

export type KeyOfIcon = (typeof icon_key_list)[number];

export type IconIndex = {
	[K in (typeof icon_key_list)[number]]:
		| string
		| FunctionComponent<any>
		| ComponentClass<any, any>;
};

const Icon: IconIndex = {
	AccountCircleOff,
	AccountCircleOn,
	AddPicture,
	ArrowDown,
	ArrowLeft,
	ArrowRight,
	ArrowUp,
	AttachFile,
	AutoAwesome,
	AutoFixHigh,
	BoxOff,
	Cached,
	ChatBubbleNow,
	ChatBubbleOff,
	ChatBubbleOn,
	CheckBoxOff,
	CheckBoxOn,
	CheckCircleOff,
	CheckCircleOn,
	Check,
	CloseCircle,
	Close,
	CloudDownloadOff,
	CloudDownloadOn,
	CreditCard,
	DashboardOff,
	DashboardOn,
	DeleteOff,
	DeleteOn,
	Download,
	DragHandle,
	DropArrowDown,
	DropArrowUp,
	Edit,
	EventOff,
	EventOn,
	ExploreOff,
	ExploreOn,
	FavoriteOff,
	FavoriteOn,
	FlagOff,
	FlagOn,
	FolderOff,
	FolderOn,
	Graph,
	HelpOutline,
	InsertComment,
	InsertLink,
	Insta,
	InstaReels,
	List,
	LockOff,
	LockOn,
	Memory,
	Menu,
	MoreHoriz,
	MoreVert,
	NaverBlog,
	Navigation,
	NotificationNow,
	NotificationOff,
	NotificationOn,
	OfferOff,
	OfferOn,
	OfflineBoltOff,
	OfflineBoltOn,
	OutLink,
	Picture,
	Pin,
	Public,
	RadioButtonOff,
	RadioButtonOn,
	RankingOff,
	RankingOn,
	RemoveCircleOff,
	RemoveCircleOn,
	RedEyeOff,
	RedEyeOn,
	Search,
	Settings,
	ShoppingCartOff,
	ShoppingCartOn,
	SideBarOff,
	SkipNext,
	SkipPrev,
	StarOff,
	StarOn,
	SupportAgent,
	Tiktok,
	Timer,
	ToggleOff,
	ToggleOn,
	Tune,
	UploadFile,
	Video,
	Verified,
	Warning,
	YoutubeShorts,
	Youtube,
};

export default Icon;
